import { global } from "../Common/saop-common";

export class SaopRevealPassword {
    private input: HTMLInputElement;
    private parentSpan: HTMLElement;
    private eye: HTMLSpanElement;
    private startedFromEmpty: boolean = false;
    private userAction: boolean = false;

    private readonly pass_common: string = "reveal-password";
    private readonly icon_pass_hidden: string = "saop-img-view si-m";
    private readonly icon_pass_reveal: string = "saop-img-hide si-m";

    constructor(input: HTMLInputElement) {
        global.ConsoleLogDegug("SaopRevealPassword.constructor");

        this.input = input;
        this.attach();
    }

    attach(): void {
        global.ConsoleLogDegug("SaopRevealPassword.attach");

        if (this.input.dataset.revealAttached) {
            return;
        }
        this.input.dataset.revealAttached = "1";

        this.findParent();
        this.createEye();

        this.addEventListeners();
    }

    findParent(): void {
        global.ConsoleLogDegug("SaopRevealPassword.createWrapper");

        const parent = this.input.parentElement;
        if (!parent) {
            throw new Error("RevealPassword: Input has no parent element");
        }

        // predpostavimo, da parent je ta span, ki ga �eli� uporabiti kot wrapper
        this.parentSpan = parent;
    }

    private createEye(): void {
        global.ConsoleLogDegug("SaopRevealPassword.createEye");

        this.eye = document.createElement("span");
        this.eye.className = `${this.pass_common} ${this.icon_pass_hidden}`;
        this.eye.style.display = "none";

        this.parentSpan.appendChild(this.eye);
    }

    private updateIcon(): void {
        global.ConsoleLogDegug("SaopRevealPassword.updateIcon");

        const show =
            this.userAction &&
            this.input.value.length > 0 &&
            document.activeElement === this.input;

        if (show) {
            this.eye.style.display = "block";
        } else {
            this.eye.style.display = "none";
        }
        this.eye.className = `${this.pass_common} ${this.input.type === "text" ? this.icon_pass_reveal : this.icon_pass_hidden
            }`;
    }
    private addEventListeners(): void {
        global.ConsoleLogDegug("SaopRevealPassword.addEventListeners");

        this.eye.addEventListener("mousedown", (e: MouseEvent) => {
            global.ConsoleLogDegug("Eye icon mousedown event.");

            e.preventDefault();
        });

        this.eye.addEventListener("click", () => {
            global.ConsoleLogDegug("SaopRevealPassword.eye click event");

            this.input.type =
                this.input.type === "password" ? "text" : "password";
            this.input.classList.add("hide-caret");
            this.updateIcon();
        });

        this.input.addEventListener("focus", () => {
            global.ConsoleLogDegug("SaopRevealPassword.focus event");

            this.startedFromEmpty = this.input.value.length === 0;
            this.userAction = false;
            this.input.classList.remove("hide-caret");
            this.updateIcon();
        });

        this.input.addEventListener("keydown", () => {
            global.ConsoleLogDegug("SaopRevealPassword.keydown event");

            if (this.startedFromEmpty) {
                this.userAction = true;
            }
        });

        this.input.addEventListener("keyup", () => {
            global.ConsoleLogDegug("SaopRevealPassword.keyup event");

            this.startedFromEmpty = this.input.value.length === 0;
        });

        this.input.addEventListener("paste", () => {
            global.ConsoleLogDegug("SaopRevealPassword.paste event");

            if (this.startedFromEmpty) {
                this.userAction = true;
            }
        });

        this.input.addEventListener("input", () => {
            global.ConsoleLogDegug("SaopRevealPassword.input event");

            this.updateIcon();
        });

        this.input.addEventListener("blur", () => {
            global.ConsoleLogDegug("SaopRevealPassword.blur event");

            this.input.type = "password";
            this.eye.style.display = "none";
        });
    }

    static scanAll(): void {
        global.ConsoleLogDegug("SaopRevealPassword.scanAll");

        const inputs = document.querySelectorAll<HTMLInputElement>(
            'input[type="password"]'
        );
        inputs.forEach((el) => {
            new SaopRevealPassword(el);
        });
    }
}

